export default __webpack_public_path__ + "static/media/Parallax-HUD-06.96cdc5da.jpg";